import { motion } from "framer-motion";
import { SKILLS } from "@/constants/testIds";

const GROUPS = [
  {
    title: "On Site",
    items: [
      "Finishing Carpentry",
      "Door Installation",
      "Trim, Baseboard & Casing",
      "Custom Built-Ins",
    ],
  },
  {
    title: "Cuts & Layout",
    items: [
      "Blueprint Reading",
      "Miter & Bevel Cutting",
      "Layout from Floor Plans",
      "Scribing & Fitting",
    ],
  },
  {
    title: "Tools",
    items: [
      "Miter Saws",
      "Table Saws",
      "Finish & Brad Nail Guns",
      "Pneumatic Tools",
    ],
  },
];

export const Skills = () => (
  <section data-testid={SKILLS.root} className="py-24 md:py-32 bg-bone-dark">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <p className="eyebrow mb-6">Craft</p>
          <h2 className="font-serif text-5xl md:text-6xl leading-[1.05]">
            What I bring to the <span className="italic">site.</span>
          </h2>
        </div>
        <p className="md:col-span-6 md:col-start-7 text-ink/70 leading-relaxed self-end">
          Skills I rely on every day across custom residential builds in
          Calgary — listed plainly because that&apos;s how the work is done.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-12 border-t hairline pt-12">
        {GROUPS.map((g, i) => (
          <motion.div
            key={g.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
          >
            <p className="eyebrow mb-6">0{i + 1} — {g.title}</p>
            <ul className="space-y-4">
              {g.items.map((it) => (
                <li
                  key={it}
                  className="font-serif text-2xl md:text-3xl leading-tight border-b hairline pb-4"
                >
                  {it}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
